import './customer-area';

import table from "./table";
import sidePeek from "./sidePeek";
import imageTooltip from "./imageTooltip";
import editableStatus from "./editableStatus";
import multipleInput from "./multipleInput";
import phoneMask from "./phoneMask";
import codeMask from "./codeMask";
import validateEmail from "./validateEmail.js";
import dateRangePicker from "./dateRangePicker";
import photoRequirementsInput from "./photoRequirementsInput";
import stripeElements from "./stripeElements";
import dragAndDrop from "./dragAndDrop";
import fileUpload from "./fileUpload";
import selectWithTextOption from "./selectWithTextOption";
import countdown from "./countdown";
import idleTimer from "./idleTimer";
import viewPhotos from "./viewPhotos";
import sliderPreview from "./sliderPreview";
import quickBuyPreview from "./quickBuyPreview";
import imagesModal from "./imagesModal";
import groupedImagesModal from "./groupedImagesModal";
import myAlbumModal from "./myAlbumModal";
import agreements from "./agreements";
import quickText from "./quickText";
import tags from "./admin/tags";
import navBarMainEventStatusColor from "./navBarMainEventStatusColor"
import csvReviewGrid from "./admin/csv-review-grid"

import pictures from "./admin/pictures";
import textingUploadFile from "./admin/textingUploadFile";
import orderPictures from "./admin/orderPictures";
import quickOrderPackages from "./admin/quick-orders/packages";
import pagination from "./admin/pagination";
import activatePaidCustomers from "./admin/registrations/activatePaidCustomers";
import requirementPictures from "./admin/requirementPictures";
import sortableList from "./admin/sortableList";
import globalSearch from "./admin/global-search";
import searchResultsPage from "./admin/search-results";
import stickyTableHeader from "./admin/sticky-table-header";
import QrCodeScan from "./QrCodeScan";
import loadingListeners from "./step-form/loadingListeners";

import mainEventPhotos from "./main-event-photos/index.js";
import qualityControlImages from "./admin/quality-control/images";
import qualityControl from "./admin/quality-control/index";
import qualityControlPhotoView from "./admin/quality-control/photoView";
import sendIcon from './admin/sendIcon';
import bulking from './table/bulking';
import tableDropdown from './table/dropdown';

import redirectToOrder from './redirectToOrder.js';
import quickCheckoutModal from './quickCheckoutModal.js';
import calculate from './calculate.js';
import photoView from './photoView/index.js';
import eventPhotos from './photoView/customerArea/eventPhotos.js';
import adminEventPhotos from './photoView/adminArea/adminEventPhotos.js';
import handleMaxInput from '../support/handleMaxInput.js';
import attachments from './attachments.js';
import photoModal from './photoModal.js';
import notificationsInfinityScroll from './notificationsInfinityScroll.js';
import photoStep from './admin/quick-orders/photoStep.js';
import quickCheckoutPhotosSelector from './admin/quickCheckoutPhotosSelector.js';

Alpine.data("csvReviewGrid", csvReviewGrid);
Alpine.data("tags", tags);
Alpine.data("table", table);
Alpine.data("bulking", bulking);
Alpine.data("tableDropdown", tableDropdown);
Alpine.data("sendIcon", sendIcon);
Alpine.data("sidePeek", sidePeek);
Alpine.data("calculate", calculate);
Alpine.data("photoView", photoView);
Alpine.data("eventPhotos", eventPhotos);
Alpine.data("adminEventPhotos", adminEventPhotos);
Alpine.data("countdown", countdown);
Alpine.data("idleTimer", idleTimer);
Alpine.data("phoneMask", phoneMask);
Alpine.data("codeMask", codeMask);
Alpine.data("validateEmail", validateEmail);
Alpine.data("dateRangePicker", dateRangePicker);
Alpine.data("imagesModal", imagesModal);
Alpine.data("imageTooltip", imageTooltip);
Alpine.data("sliderPreview", sliderPreview);
Alpine.data("quickBuyPreview", quickBuyPreview);
Alpine.data("editableStatus", editableStatus);
Alpine.data("multipleInput", multipleInput);
Alpine.data("groupedImagesModal", groupedImagesModal);
Alpine.data("myAlbumModal", myAlbumModal);
Alpine.data("photoRequirementsInput", photoRequirementsInput);
Alpine.data("stripeElements", stripeElements);
Alpine.data("dragAndDrop", dragAndDrop);
Alpine.data("fileUpload", fileUpload);
Alpine.data("viewPhotos", viewPhotos);
Alpine.data("agreements", agreements);
Alpine.data("selectWithTextOption", selectWithTextOption);
Alpine.data("quickText", quickText);
Alpine.data("pictures", pictures);
Alpine.data("textingUploadFile", textingUploadFile);

Alpine.data("mainEventPhotos", mainEventPhotos);

Alpine.data("QrCodeScan", QrCodeScan);
Alpine.data("loadingListeners", loadingListeners);

Alpine.data("qualityControlImages", qualityControlImages);
Alpine.data("qualityControl", qualityControl);
Alpine.data("qualityControlPhotoView", qualityControlPhotoView);
Alpine.data("orderPictures", orderPictures);
Alpine.data("quickOrderPackages", quickOrderPackages);
Alpine.data("pagination", pagination);
Alpine.data("activatePaidCustomers", activatePaidCustomers);
Alpine.data("requirementPictures", requirementPictures);
Alpine.data("sortableList", sortableList);
Alpine.data("globalSearch", globalSearch);
Alpine.data("searchResultsPage", searchResultsPage);
Alpine.data("stickyTableHeader", stickyTableHeader);

Alpine.data("redirectToOrder", redirectToOrder);
Alpine.data("quickCheckoutModal", quickCheckoutModal);

Alpine.data("navBarMainEventStatusColor", navBarMainEventStatusColor)
Alpine.data("handleMaxInput", handleMaxInput);
Alpine.data("attachments", attachments);
Alpine.data("photoModal", photoModal);
Alpine.data("notificationsInfinityScroll", notificationsInfinityScroll);
Alpine.data("photoStep", photoStep);
Alpine.data("quickCheckoutPhotosSelector", quickCheckoutPhotosSelector);
